<template>
    <Fragment>
        <div class="radio-group" @click="onChangePaymentRadio">
            <div class="radio-heading">
                <span class="radio-conteiner">
                    <input
                        type="radio"
                        name="payment_radio"
                        :value="payment_data"
                        v-model="payment_selected"
                        @change="onChangePaymentRadio($event)"
                    >
                </span>
                <span class="forma-conteiner">
                    <i class="fas fa-credit-card"></i>
                    Cartão de crédito
                </span>
            </div>
        </div>
        <div class="content-payment">
                <div v-if="payment_selected && payment_data.id == payment_selected.id">
                    <!--NUMBER CARD-->
                    <div class="form-group required-field">
                        <label for="numberCardIpag">Número do cartão de crédito</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="numberCardIpag"
                            name="numberCardIpag"
                            :value="number"
                            @input="$emit('update:number', $event.target.value)"
                        />
                        <div v-if="validate.formBellunoCard.number.$error && !validate.formBellunoCard.number.required" class="required">* Obrigatório</div>
                        <div v-if="!cardValid" class="required">Não aceitamos esta bandeira de cartão</div>
                    </div>
                    <!--END NUMBER CARD-->
                    <!--HOLDER CARD-->
                    <div class="form-group required-field">
                        <label for="cardholder_name">Titular do cartão</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="cardholder_name"
                            name="cardholder_name"
                            v-uppercase
                            :value="holder"
                            @input="$emit('update:holder', $event.target.value)"
                        />
                        <div v-if="validate.formBellunoCard.holder.$error && !validate.formBellunoCard.holder.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END HOLDER CARD-->
                    <!--DOCUMENT_NUMBER HOLDER-->
                    <div class="form-group required-field">
                        <label for="cardholder_document">CPF/CNPJ do titular</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="cardholder_document"
                            name="cardholder_document"
                            :value="cardholder_document"
                            @input="$emit('update:cardholder_document', $event.target.value)"
                            v-mask="( cardholder_document.length <= 14 ) ? '###.###.###-##' : '##.###.###/####-##'"
                        />
                        <div v-if="validate.formBellunoCard.cardholder_document.$error && !validate.formBellunoCard.cardholder_document.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END DOCUMENT_NUMBER HOLDER-->

                     <!--BIRTHDATE HOLDER-->
                    <div class="form-group required-field">
                        <label for="cardholder_birth">Data de nascimento do titular</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="cardholder_birth"
                            name="cardholder_birth"
                            :value="cardholder_birth"
                            @input="$emit('update:cardholder_birth', $event.target.value)"
                            v-mask="'##/##/####'"
                        />
                        <div v-if="validate.formBellunoCard.cardholder_birth.$error && !validate.formBellunoCard.cardholder_birth.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END BIRTHDATE HOLDER-->

                       <!--PHONE_NUMBER HOLDER-->
                    <div class="form-group required-field">
                        <label for="cardholder_cellphone">Celular do titular</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="cardholder_cellphone"
                            name="cardholder_cellphone"
                            :value="cardholder_cellphone"
                            @input="$emit('update:cardholder_cellphone', $event.target.value)"
                            v-mask="'(##) #####-####'"
                        />
                        <div v-if="validate.formBellunoCard.cardholder_cellphone.$error && !validate.formBellunoCard.cardholder_cellphone.required" class="required">* Obrigatório</div>
                         <div v-if="validate.formBellunoCard.cardholder_cellphone.$error && !validate.formBellunoCard.cardholder_cellphone.minLength" class="required">* Número inválido</div>
                    </div>
                    <!--END PHONE_NUMBER HOLDER-->

                    <!--BRAND CARD-->
                    <div class="form-group required-field">
                        <label for="brandCardIpag">Bandeira do cartão</label>
                        <select
                            class="form-payment"
                            @input="$emit('update:method', $event.target.value)"
                        >
                            <option value="" selected>Selecione a bandeira</option>
                            <option v-for="item in payment_data.payment_method" :key="item.id" :value="item.method">{{item.method}}</option>
                        </select>
                        <div v-if="validate.formBellunoCard.method.$error && !validate.formBellunoCard.method.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END BRAND CARD-->

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group required-field mb-0">
                                <label>Vencimento do cartão</label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group required-field mb-0">
                                <label>Cvv</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <!--EXPIRY MONTH-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_month', $event.target.value)"
                            >
                                <option value="" selected>Mês</option>
                                <option v-for="count in 12" :key="count" :value="count < 10 ? '0'+count : count">{{ count < 10 ? '0'+count : count }}</option>
                            </select>
                            <div v-if="validate.formBellunoCard.expiry_month.$error && !validate.formBellunoCard.expiry_month.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY MONTH-->

                        <!--EXPIRY YEAR-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_year', $event.target.value)"
                            >
                                <option value="" selected>Ano</option>
                                <option v-for="(n, $index) in 12" :key="n" :value="$index + countDate">{{$index + countDate}}</option>
                            </select>
                            <div v-if="validate.formBellunoCard.expiry_year.$error && !validate.formBellunoCard.expiry_year.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY YEAR-->

                        <!--CVV CARD-->
                        <div class="col-md-4">
                            <input
                                type="text"
                                class="form-payment"
                                id="cvvIpag"
                                name="cvvIpag"
                                :max-length="maxlengthCvv"
                                placeholder="cvv"
                                @input="$emit('update:cvv', $event.target.value)"
                            />
                            <div
                                v-if="validate.formBellunoCard.cvv.$error && !validate.formBellunoCard.cvv.required"
                                class="required"
                            >
                                * Obrigatório
                            </div>
                        </div>
                        <!--END CVV CARD-->
                    </div>

                    <!--INSTALLMENTS-->
                    <div class="form-group required-field">
                        <label for="installments_ipag">Parcelas</label>
                         <select class="form-payment" @input="$emit('update:installment', $event.target.value)">
                            <option v-for="i in maxNumberOfInstallments" :key="i" :value="i" :selected="i == 1">
                                {{showInstallment(i)}}
                            </option>
                        </select>
                        <div v-if="validate.formBellunoCard.installment.$error && !validate.formBellunoCard.installment.required" class="required">* Selecione uma parcela</div>
                    </div>
                    <!--END INSTALLMENTS-->
                </div>
        </div>
    </Fragment>
</template>

<script>
import {Fragment}  from 'vue-fragment'
import moment from 'moment'
import {mapState, mapActions} from 'vuex'
import Currency from '../../helpers/parseCurrency'

export default {
    name: 'Ipag',
    directives: {
        "uppercase": {
            update: function (el) {
                el.value = el.value.toUpperCase()
            }
        }
    },
    props: {
        //numero de parcelas sem juros definido pela empresa no painel administrativo
        interest_free_installments: {
            default: 0
        },
        payment_data: {
            required: true,
            default: Object,
            type: Object
        },
        payment_selected: {
            default: Object,
            type: Object
        },
        holder: {
            default: ''
        },
        method: {
            default: '',
        },
        number: {
            default: ''
        },
        expiry_month: {
            default: ''
        },
        expiry_year: {
            default: ''
        },
        cvv: {
            default: ''
        },
        installment: {
            default: ''
        },
        validate: {
            required: true
        },
        cardholder_document: {
            default: ''
        },
        cardholder_cellphone: {
            default: ''
        },
        cardholder_birth: {
            default: ''
        },
    },
    components: {
        Fragment
    },
    data() {
        return {
            moment: moment,
            maxlengthCvv: 3,
            installments: 10,
            disabledInstallments: true,
            countDate: 0,
            currency: Currency,
            cardValid: true
        }
    },
    created() {
        this.countDate = parseInt(this.moment().format('YYYY'))
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemsCart"
        ]),
        onChangeInstallment(event) {
            let selected = event.target.value.split(';')
            let itemsCart = this.itemsCart
            itemsCart.totalAmount = selected[2]
            this.ActionSetItemsCart(itemsCart)
        },
        onChangePaymentRadio() {
            this.$emit('onChangePayment', this.payment_data)
        },
        showInstallment(index) {
           return `${index == 1 ? 'À vista - ': index + 'x de '}${this.currency.money(this.addInstallmentFeeToTotalAmount(index) / index)} ${this.validateWithOrWithoutAditionals(index)}`;
        },
        validateWithOrWithoutAditionals(index) {
            if(index > Number(this.interest_free_installments ?? 0) && Number(this.payment_selected.installment_fee ?? 0) > 0){
                return "com juros";
            }
            return index == 1 ? '' : "sem juros";
        },
        addInstallmentFeeToTotalAmount(index) {
            if(index > (this.interest_free_installments ?? 0)) {
                //return Number(this.totalAmount) + (Number(this.totalAmount) * (Number(this.payment_selected.installment_fee ?? 0) / 100))
                let taxa = this.payment_selected.installment_fee / 100;
                let totalAmount = (this.totalAmount * ((Math.pow((1 + taxa), index) * taxa) / (Math.pow((1 + taxa), index) - 1))) * index;
                return totalAmount.toFixed(2);
            }

            return this.totalAmount
        },
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        maxNumberOfInstallments() {
            let installments = [this.maxInstallments]
            if(Number(this.payment_selected.price_min_split ?? null) > 0) {
                let split = Math.floor(this.totalAmount / Number(this.payment_selected.price_min_split))
                if(split > 12) {
                    split = 12;
                }else if(split < 1) {
                    split = 1
                }
                installments.push(split)
            }
            return Math.min.apply(Math, installments)
        },
        maxInstallments() {
            if( !this.payment_selected.max_installments || this.payment_selected.max_installments < 1 ) {
                return 12;
            }
            return this.payment_selected.max_installments
        },
        totalAmount() {
            return this.itemsCart.totalAmount.toFixed(2)
        }
    }
}
</script>
